<template>
  <div class="n_page">
    <div class="group1">
      <div class="main2">
        <div class="section2">
          <div
            class="n_noaddress address_width"
            v-if="JSON.stringify(defaultAddress) == '{}'"
            @click="jump"
          >
            <div class="n_noaddress">
              <img :src="imgPath+'yj_icon-map.png'" alt />
              <span class="n_select">添加收货地址</span>
            </div>
          </div>
          <div
            class="main3 flex aliten_center"
            @click="jump"
            v-if="JSON.stringify(defaultAddress) != '{}'"
          >
            <img class="n_biao" :src="imgPath+'yj_icon-map.png'" alt />
            <div class="aliten_center flex space_bettw">
              <div class="n_margin">
                <div class="wrap3">
                  <span class="n_name">{{defaultAddress.consignee}}</span>
                  &nbsp;&nbsp;
                  <span class="n_phone">{{defaultAddress.phone}}</span>
                </div>
                <div
                  class="n_provi"
                  v-if="defaultAddress.address_detail"
                >{{defaultAddress.address_detail.level_1_name + defaultAddress.address_detail.level_2_name + defaultAddress.address_detail.level_3_name + defaultAddress.address_detail.level_4_name + defaultAddress.address}}</div>
              </div>
              <span class="iconfont iconnavigate-right"></span>
            </div>
          </div>
          <div class="main4">
            <div class="wrap4" v-for="item in goodsList" :key="item.spec_id">
              <div class="layer1">
                <img class="img1" referrerpolicy="no-referrer" :src="item.images" />
              </div>
              <div class="layer2">
                <p class="info2">{{item.goods_name}}</p>
                <div class="layer3">
                  <span class="txt3">{{item.spec_name}}</span>
                  <span class="yj_gg">x{{item.num}}</span>
                </div>
                <div class="layer4" v-if="item.is_mz == 0">
                  <i v-if="goods_type != 'integral'">¥</i>
                  {{ goods_type == 'integral' ? item.score : goods_type == 'package' ? item.market_price : item.price}}
                </div>
                <div class="layer4" v-else>赠品</div>
              </div>
            </div>
          </div>
          <div
            class="main8"
            v-if="(goods_type == 'package' || goods_type=='receive_package') && info.package_info && info.package_info.score > 0"
          >
            <div class="main9">
              <div class="main9_left">
                <div class="outer1">
                  <img :src="imgPath+'icon_integralss.png'" alt />
                </div>
                <span class="word8">提货卡</span>
              </div>
              <span class="txt6" v-if="info.package_info">{{info.package_info.score}}</span>
            </div>
            <div class="n_timer">仅限提货专区使用 有效期两年</div>
          </div>
          <div class="main5">
            <p>买家留言</p>
            <textarea maxlength="50" placeholder="选填(50字以内)" v-model="message"></textarea>
          </div>
          <div class="main6">
            <div class="box1">
              <span class="txt4">商品小计</span>
              <div class="box1_right">
                <span class="word6">共{{info.goods_count}}件商品&nbsp;合计：</span>
                <span
                  class="info4"
                  v-if="goods_type == 'integral' || goods_type == 'integral_group'"
                >{{info.pay_integral}}</span>
                <span
                  :class="[goods_type == 'package' ? 'decoration_n' : '','info4']"
                  v-else-if="goods_type == 'package'"
                >¥{{info.goods_market_all_money}}</span>
                <span
                  :class="[goods_type == 'package' ? 'decoration_n' : '','info4']"
                  v-else
                >¥{{info.goods_all_money}}</span>
              </div>
            </div>
          </div>
          <div class="main7">
            <div class="wrap5">
              <span class="txt5">运费</span>
              <span class="word7">{{info.shipping_fee > '0.00' ? '¥' + info.shipping_fee : '包邮'}}</span>
            </div>
          </div>
          <div class="main7" v-if="info.packet_money > 0">
            <div class="wrap5">
              <span class="txt5">红包抵扣</span>
              <span class="word7">-{{info.packet_money}}</span>
            </div>
          </div>
          <div class="main7" v-if="goods_type == 'package'">
            <div class="wrap5">
              <span class="txt5">礼包价</span>
              <span class="word7">￥{{info.gif_price}}</span>
            </div>
          </div>
          <div
            class="n_banner"
            @click="$router.push({path:'../giftBig'})"
            v-if="goods_type != 'integral' && goods_type != 'integral_group' && goods_type != 'pick_up' && goods_type != 'package'&& is_distributor != 1"
          >
            <img :src="imgPath + 'yj_tyg_banner.png'" alt />
          </div>
          <div class="select_pay">
            <van-radio-group v-model="radio" @change="selectPayMh">
              <div class="flex just_beetw">
                <div class="flex alitem_center">
                  <img :src="imgPath + 'yj_t_icon_zhifu@2x.png'" alt />
                  <div>
                    <p class="wx_pay">微信支付</p>
                    <p class="aq_pay">微信安全支付</p>
                  </div>
                </div>
                <van-radio name="1" icon-size="24px" checked-color="#ee0a24"></van-radio>
              </div>
              <div class="flex just_beetw mt_two">
                <div class="flex alitem_center">
                  <img :src="imgPath + 'yj_t_kuaijiezhifu@2x.png'" alt />
                  <div>
                    <p class="wx_pay">快捷支付</p>
                  </div>
                </div>
                <van-radio name="2" icon-size="24px" checked-color="#ee0a24"></van-radio>
              </div>
              <div class="flex just_beetw mt_two" v-if="bankInfo.bank_no">
                <p></p>
                <div>
                  <span class="blank">{{bankInfo.bank_name}}</span>
                  <span class="blank_sn">尾号{{bankInfo.bank_no}}</span>
                </div>
              </div>
            </van-radio-group>
          </div>
          <div class="n_footer"></div>
          <div class="main10" v-if="myInfo.mobile != ''">
            <div class="group2">
              <div class="zn_payj">
                需支付
                <i v-if="goods_type != 'integral' && goods_type != 'integral_group'">￥</i>
                <b
                  v-if="goods_type == 'integral' || goods_type == 'integral_group'"
                >{{info.pay_integral}} {{'+运费￥' + info.pay_money}}</b>
                <b v-else>{{info.pay_money}}</b>
              </div>
              <button
                class="layer6"
                v-if="goods_type == 'package' && nosendInfo.package_no_send == 1"
                @click="isShowFg"
              >
                <span class="txt8">确认订单</span>
              </button>
              <button class="layer6" @click="creatOrerd" v-else>
                <span class="txt8">确认订单</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="show"
      show-cancel-button
      confirmButtonText="直接发货"
      cancelButtonText="暂不发货"
      @confirm="confirmFg"
      @cancel="cancelFg"
    >
      <div class="n_tab">
        <div class="n_tips">
          <p class="n_title">{{nosendInfo.goods_name}}是否直接发货？</p>
          <p class="n_red">注：暂不发货指可在需要时在个人中心进行提货</p>
        </div>
      </div>
    </van-dialog>
    <van-action-sheet
      v-model="isShowPhone"
      title="请您绑定手机号~~"
      :closeable="false"
      :close-on-click-overlay="false"
    >
      <div class="n_content">
        <van-field v-model="formData.mobile" placeholder="请输入手机号" type="tel" label="手机号" />
        <van-field v-model="formData.code" center clearable label="短信验证码" placeholder="请输入短信验证码">
          <template #button>
            <van-button
              size="small"
              type="primary"
              class="n_button"
              @click="smsSend"
            >{{sign == false ? '发送验证码' : codehtml + 'S'}}</van-button>
          </template>
        </van-field>
        <div class="what">
          <!-- <div class="sc" style="background:#EDEDED;color:#0CC060" @click="show = false">暂不绑定</div> -->
          <div class="sc" style="background:#0CC060;color:#fff" @click="land">立即绑定</div>
        </div>
      </div>
    </van-action-sheet>
    <toastMune v-if="messageFile != ''" :isToast="isToast" :message="messageFile"></toastMune>
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant'
import masterPath from '../../../config.js'
import toastMune from '../../components/toast.vue'
document.body.style.backgroundColor = '#F7F8FA'
export default {
  components: { toastMune },
  name: 'ConfirmOrder',
  data() {
    return {
      constants: {},
      defaultAddress: {}, //默认地址
      goodsList: [],
      info: {},
      show: false,
      goods_type: '',
      no_send: null,
      nosendInfo: {}, //不发货商品
      message: '',
      isToast: false,
      messageFile: '',
      isShowPhone: false,
      formData: { mobile: '', code: '' },
      codehtml: 60, //倒计时秒
      sign: false, //倒计时
      myInfo: {},
      is_distributor: '',
      radio: '1',
      bankInfo: {}, //快捷支付银行卡信息
    }
  },
  created() {
    console.log(this.$route.query)
    if (!this.$route.query.encodeData && !this.$route.query.order_id) {
      this.getDefaultAddress()
    } else if (!this.$route.query.order_id) {
      console.log('111--*')
      this.defaultAddress = JSON.parse(this.$route.query.encodeData)
      this.getLeteOrder()
    } else if (this.$route.query.order_id) {
      this.getOrderDetail()
    }
    this.getUserInfo()
  },
  mounted() {
    this.init()
    this.prohibitweixinShare()
    this.goods_type = localStorage.getItem('type')
  },
  methods: {
    //获取订单详情
    getOrderDetail() {
      this.http('ClientOrder.childDetail', {
        order_id: this.$route.query.order_id,
      }).then((res) => {
        if (res.status == 200) {
          this.goodsList = res.content.child_order_list
          res.content.child_order_list.map((item) => {
            if (item.package_no_send == 1) {
              this.nosendInfo = item
            }
          })
          this.info = res.content
        } else {
          Toast(res.msg)
        }
      })
    },
    //基本信息
    getUserInfo() {
      this.http('Client.index', {}).then((res) => {
        this.is_distributor = res.content.user_info.is_distributor
      })
    },
    //基本信息
    init() {
      this.http('Client.index', {}).then((res) => {
        console.log(res)
        if (res.status == 200) {
          this.myInfo = res.content.user_info
          if (res.content.user_info.mobile == '') {
            this.isShowPhone = true
          } else {
            console.log('2222')
            this.isShowPhone = false
          }
          console.log(this.myInfo)
        }
      })
    },
    smsSend() {
      if (!/^[1][0-9]{10}$/.test(this.formData.mobile)) {
        Toast('手机号码有误，请重填')
        return false
      }
      if (this.sign) return
      //获取验证码
      let { mobile, code, verifyCode } = this.formData
      this.http('Base.smsSend', { mobile: mobile }).then((res) => {
        if (res.status == 200) {
          console.log(res, '3333333')
          this.codehtml = 60
          this.sign = true
          let tim = setInterval(() => {
            this.codehtml = this.codehtml - 1
            if (this.codehtml <= 0) {
              clearInterval(tim)
              this.sign = false
              return false
            }
          }, 1000)
          this.time = tim
        } else {
          Toast(res.msg)
        }
      })
    },
    //登陆按钮
    land(e) {
      console.log('1')
      console.log(this.formData.mobile)
      if (this.formData.mobile == '') {
        Toast('请先输入手机号')
        return
      }
      if (this.formData.code == '') {
        Toast('请先输入验证码')
        return
      }
      let flag = false
      if (flag) return
      flag = true
      let { mobile, code, verifyCode } = this.formData
      this.formData.share_sign_no = localStorage.getItem('shareId') || ''
      this.http('Client.signUp', this.formData).then((res) => {
        if (res.status == 200) {
          this.init()
          console.log(res, 'response.data.content')
          // this.$store.commit('increment', '成功')
          let contentListy = JSON.parse(localStorage.getItem('userInfo'))
          contentListy.mobile = res.content.mobile
          contentListy = JSON.stringify(contentListy)
          localStorage.setItem('userInfo', contentListy)
          this.isShowPhone = false
          flag = false
        } else {
          // Toast(res.msg)
          this.$store.commit('increment', res.msg)
          flag = false
        }
      })
    },
    isShowFg() {
      this.show = true
    },
    confirmFg() {
      this.no_send = 0
      console.log('111')
      this.creatOrerd()
    },
    cancelFg() {
      this.no_send = 1
      console.log('222')
      this.creatOrerd()
    },
    //获取订单
    async getLeteOrder(data, type) {
      let params
      let paramsType = localStorage.getItem('type')
      if (paramsType == 'buy' || paramsType == 'integral') {
        params = 'goods_data'
      } else if (paramsType == 'cart') {
        params = 'cart_data'
      } else {
        params = 'goods_data'
      }
      let objParams = {}
      let live_id = window.sessionStorage.getItem('live_id')
      if (live_id) {
        objParams = {
          live_id,
          scenes_id: window.sessionStorage.getItem('scenes_id'),
        }
      }
      console.log(
        JSON.parse(sessionStorage.getItem('vuex')).shopingType,
        '--------'
      )
      let res = await this.http('ClientOrder.beforeCreateOrder', {
        type: localStorage.getItem('type'),
        [params]: localStorage.getItem('spec_id'),
        num: localStorage.getItem('num') || null,
        package_id: localStorage.getItem('package_id'),
        transfer_id: localStorage.getItem('spec_id'),
        spec_id: localStorage.getItem('spec_id'),
        batch_id: localStorage.getItem('batch_id'),
        address_id: this.defaultAddress.id,
        share_sign_no:
          JSON.parse(sessionStorage.getItem('vuex')).shopingType == 0
            ? sessionStorage.getItem('shareId')
            : localStorage.getItem('shareId'),
        activity_type: localStorage.getItem('activity_type'),
        rank_id: localStorage.getItem('rank_id'),
        mt_id: localStorage.getItem('mt_id') || '',
        ...objParams,
      })
      if (res.status == 200) {
        this.goodsList = res.content.goods_list
        res.content.goods_list.map((item) => {
          if (item.package_no_send == 1) {
            this.nosendInfo = item
          }
        })
        this.info = res.content
        console.log(res)
        localStorage.setItem('user_integral', res.content.user_integral)
      } else {
        this.messageFile = res.msg
        this.$nextTick(() => {
          this.isToast = true
          setTimeout(() => {
            this.isToast = false
          }, 1000)
          // Toast.fail(res.msg)
          setTimeout(() => {
            this.$router.back(-1)
          }, 1200)
        })
      }
    },
    //获取默认地址
    async getDefaultAddress() {
      let res = await this.http('ClientAddress.getDefaultAddress', {})
      if (res.status == 200) {
        this.defaultAddress = res.content
        this.getLeteOrder()
      } else {
        Dialog.alert({
          message: res.msg,
        }).then(() => {
          this.$router.push({
            path: '../cityList',
            query: { type: 'comfirm', param: this.$route.query.param },
          })
          // on close
        })
        this.defaultAddress = {}
      }
    },
    //创建订单
    async creatOrerd() {
      let params
      let shopNum = null
      let paramsType = localStorage.getItem('type')
      if (paramsType == 'buy' || paramsType == 'integral') {
        params = 'goods_data'
      } else if (paramsType == 'cart') {
        params = 'cart_data'
      } else if (
        paramsType == 'package' ||
        paramsType == 'integral_group' ||
        paramsType == 'activity'
      ) {
        shopNum = localStorage.getItem('num')
        params = 'cart_data'
      }
      let objParams = {}
      let live_id = window.sessionStorage.getItem('live_id')
      if (live_id) {
        objParams = {
          live_id,
          scenes_id: window.sessionStorage.getItem('scenes_id'),
        }
      }
      let res = await this.http('ClientOrder.createOrder', {
        type: paramsType,
        [params]: localStorage.getItem('spec_id'),
        address_id: this.defaultAddress.id,
        num: localStorage.getItem('num') || null,
        package_id: localStorage.getItem('package_id'),
        no_send: this.no_send,
        transfer_id: localStorage.getItem('spec_id'),
        spec_id: localStorage.getItem('spec_id'),
        message: this.message,
        batch_id: paramsType == 'buy' ? null : localStorage.getItem('batch_id'),
        share_sign_no:
          JSON.parse(sessionStorage.getItem('vuex')).shopingType == 0
            ? sessionStorage.getItem('shareId')
            : localStorage.getItem('shareId'),
        activity_type: localStorage.getItem('activity_type'),
        rank_id: localStorage.getItem('rank_id'),
        mt_id: localStorage.getItem('mt_id') || '',
        ...objParams,
      })
      if (res.status == 200) {
        localStorage.setItem('order_id', res.content.order_id)
        let params = {
          token: localStorage.getItem('token'),
          mechId: localStorage.getItem('mechId'),
          sn: res.content.order_sn,
          transfer_ids: 0,
          type: localStorage.getItem('type'),
          seler: this.radio == '2' ? 'rule' : 'pay',
        }
        let str = ''
        for (let i in params) {
          str += `${i}=${params[i]}&`
        }
        str = str.slice(0, str.length - 1)
        window.location.href = `${
          masterPath.masterPay
        }/cashierDesk?${encodeURIComponent(str)}`
        // price=${
        //   this.goods_type == 'integral' || this.goods_type == 'integral_group'
        //     ? this.info.pay_integral
        //     : res.content.pay_money
        // }
        // window.location.href = `${masterPath.masterPay}/cashierDesk?orderSn=${
        //   res.content.order_id
        // }&token=${localStorage.getItem('token')}&mechId=${localStorage.getItem(
        //   'mechId'
        // )}&sn=${res.content.order_sn}&type=${localStorage.getItem(
        //   'type'
        // )}&transfer_ids=${0}&seler=${this.radio == '2' ? 'rule' : 'pay'}`
      } else {
        Toast(res.msg)
      }
    },
    jump() {
      this.$router.push({
        path: '../cityList',
        query: { type: 'comfirm', param: this.$route.query.param },
      })
    },
    // 选择支付方式
    selectPayMh(event) {
      console.log(event)
      if (event == 2) {
        this.getAuthInfo()
      }
    },
    //查询是否认证
    getAuthInfo() {
      this.http('MemberAuth.getAuthInfo', {}).then((res) => {
        console.log(res)
        if (res.content.auth_data.is_identity_checked == 1) {
          this.$router.push({
            path: '/realName',
            query: {
              real_name_fee: res.content.auth_data.real_name_fee_dollar,
              is_identity_checked: res.content.auth_data.is_identity_checked,
              is_acct_checked: res.content.auth_data.is_acct_checked,
              user: 'rule',
            },
          })
        } else {
          this.getUserBank(res.content.auth_data)
        }
      })
    },
    // 获取电子协议url
    getSignContract() {
      this.http('MemberAuth.signContract', {}).then((res) => {
        if (res.status == 200) {
          console.log(res)
          window.location.href = res.content.url
        }
      })
    },
    //查询是否绑定银行卡
    getUserBank(authInfo) {
      this.http('Client.getUserBank', { type: 2 }).then((res) => {
        if (res.content.length == 0) {
          Dialog.confirm({
            title: '温馨提示',
            message: '您还未绑定银行卡，请前去绑卡',
          })
            .then(() => {
              console.log('222')
              this.$router.replace({
                path: '/bindingBank',
                query: {
                  identity_card_no: authInfo.identity_card_no,
                  name: authInfo.name,
                  user: 'rule',
                },
              })
            })
            .catch(() => {
              this.radio = '1'
            })
        } else {
          this.bankInfo = res.content
          this.bankInfo.bank_no = res.content.bank_card_no.substring(
            res.content.bank_card_no.length - 4
          )
        }
      })
    },
  },
}
</script>
<style scoped>
.n_footer {
  height: 180px;
}
.zn_payj {
  float: left;
  color: #999999;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.zn_payj i {
  color: #f5223d;
  font-size: 24px;
}
.zn_payj b {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #f5223d;
}

.van-cell {
  background: none !important;
}
</style>

<style scoped lang="scss">
.sc {
  border-radius: 5px;
  background: red;
  height: 80px;
  // width: 200px;
  text-align: center;
  margin: 0 20px;
  font-size: 24px;
  line-height: 80px;
}
.n_content {
  min-height: 400px;
  box-sizing: border-box;
  padding: 20px 30px;
}
.n_button {
  padding: 5px 10px;
}
.n_banner {
  // position: fixed;
  // bottom: 150px;
  // left: 50%;
  // transform: translate(-50%);
}
.n_banner img {
  display: block;
  width: 710px;
  margin: 100px auto 30px;
}
.n_filed {
  width: 100%;
}
.n_page {
  min-height: 100vh;
  background: #f7f8fa;
}
.icondingwei3 {
  font-size: 50px;
  margin-left: 30px;
}
.group1 {
  width: 750px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.pic1 {
  width: 656px;
  height: 24px;
  align-self: flex-end;
  margin-right: 28px;
}

.main1 {
  width: 694px;
  height: 64px;
  margin-left: 44px;
  margin-top: 42px;
  flex-direction: row;
  display: flex;
}

.section1 {
  width: 20px;
  height: 36px;
  background-image: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yl_leftarrow1.png');
  background-repeat: no-repeat;
  background-size: 100%;
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.info1 {
  width: 144px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 36px;
  font-family: PingFangSC-Medium;
  line-height: 36px;
  text-align: center;
  margin-top: 14px;
  margin-left: 239px;
}

.pic2 {
  ////z-index: 44;
  width: 176px;
  height: 64px;
  margin-left: 115px;
}

.main2 {
  height: 100%;
  background-color: rgba(247, 248, 250, 1);
  align-self: center;
  width: 750px;
  justify-content: flex-end;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.section2 {
  height: 100%;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.main3 {
  width: 710px;
  box-sizing: border-box;
  background: #ffffff;
  padding: 28px 26px;
  margin: 20px auto 0;
}

.wrap1 {
  padding: 2px 10px;
  font-size: 20px;
  color: #ffffff;
  background: #f0240e;
  border-radius: 14px;
}
.n_provi {
  font-size: 24px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.iconnavigate-right {
  font-size: 40px;
}
.n_biao {
  display: block;
  width: 50px;
  height: 50px;
}
.n_margin {
  margin-left: 30px;
}
.wrap2 {
  justify-content: space-between;
  margin: 20px 0;
  background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_arrow.png')
    no-repeat right center;
  background-size: 40px 40px;
}

.txt2 {
  font-size: 32px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.label1 {
  width: 32px;
  height: 32px;
}
.n_name {
  font-size: 32px;
  color: #333333;
}
.n_phone {
  font-size: 24px;
  color: #999999;
}
.main4 {
  border-radius: 14px;
  background-color: rgba(255, 255, 255, 1);
  align-self: center;
  margin-top: 22px;
  width: 710px;
  justify-content: center;
  align-items: flex-start;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.wrap4 {
  width: 592px;
  padding: 15px 0;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
}

.layer1 {
  position: relative;
  width: 140px;
  height: 140px;
  border-radius: 16px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.img1 {
  position: absolute;
  left: 0;
  top: 0;
  width: 140px;
  height: 140px;
}

.layer2 {
  width: 420px;
  margin-top: 5px;
  display: flex;
  flex-direction: column;
}

.info2 {
  width: 420px;
  font-size: 28px;
  text-align: left;
  display: block;
  overflow: hidden; //溢出隐藏
  text-overflow: ellipsis; //超出显示省略号
  white-space: nowrap; //强制文本在一行内显示
}
.yj_gg {
  font-size: 24px;
  color: #999;
  margin-left: 20px;
  margin-top: -5px;
}
.layer3 {
  height: 40px;
  align-self: flex-start;
  margin-top: 13px;
}

.txt3 {
  ////z-index: 68;
  /*width: 75px;*/
  float: left;
  background-color: rgba(242, 242, 242, 1);
  height: 40px;
  line-height: 40px;
  padding: 0 5px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 24px;
  font-family: PingFang-SC-Medium;
  text-align: center;
  border-radius: 8px;
}

.layer4 {
  ////z-index: auto;
  // width: 108px;
  height: 34px;
  margin-top: 17px;
  font-size: 34px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #f0240e;
}
.layer4 i {
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #f0240e;
}

.word3 {
  ////z-index: 63;
  //width: 17px;
  float: left;
  overflow-wrap: break-word;
  color: rgba(240, 36, 14, 1);
  font-size: 28px;
  font-family: PingFangSC-Semibold;
  line-height: 28px;
  text-align: center;
  margin-top: 5px;
}

.word4 {
  ////z-index: 64;
  float: left;
  overflow-wrap: break-word;
  color: rgba(240, 36, 14, 1);
  font-size: 34px;
  font-family: PingFangSC-Semibold;
  line-height: 34px;
  text-align: left;
}

.main5 {
  width: 710px;
  margin: 20px auto 0;
  background: #fff;
  border-radius: 10px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #323233;
  p {
    line-height: 60px;
    padding: 0 20px;
  }
  textarea {
    padding: 0 20px;
    display: block;
    font-size: 24px;
    width: 100%;
    box-sizing: border-box;
  }
}
.n_noaddress .iconnext {
  margin-right: 50px;
}
.n_noaddress img {
  width: 50px;
  height: 50px;
  margin-left: 30px;
}
.address_width {
  width: 710px;
  height: 120px;
  background: #ffffff
    url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_arrow.png')
    no-repeat 650px center;
  background-size: 30px 30px;
  border-radius: 14px 10px 10px 10px;
  box-sizing: border-box;
  margin: 20px auto 0;
}
.n_noaddress {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.n_select {
  padding-left: 20px;
}
//.mod1 {
//  ////z-index: auto;
//  /*width: 197px;*/
//  height: 84px;
//  display: flex;
//  flex-direction: column;
//  .van-cell {
//    padding: 0px;
//  }
//}

//.word5 {
//  ////z-index: 59;
//  /*width: 112px;*/
//  display: block;
//  overflow-wrap: break-word;
//  color: rgba(50, 50, 51, 1);
//  font-size: 28px;
//  font-family: PingFangSC-Regular;
//  line-height: 40px;
//  text-align: left;
//  align-self: flex-start;
//}

.info3 {
  ////z-index: 60;
  width: 197px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(150, 151, 153, 1);
  font-size: 24px;
  font-family: PingFangSC-Regular;
  line-height: 24px;
  text-align: left;
  align-self: center;
  margin-top: 20px;
}

.main6 {
  ////z-index: 33;
  height: 72px;
  border-radius: 14px 14px 0 0;
  background-color: rgba(255, 255, 255, 1);
  align-self: center;
  margin-top: 20px;
  width: 710px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.box1 {
  ////z-index: auto;
  width: 650px;
  height: 26px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}
.box1_right {
  display: flex;
}
.txt4 {
  ////z-index: 35;
  display: block;
  line-height: 26px;
  text-align: left;
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}

.word6 {
  ////z-index: 36;
  /*width: 207px;*/
  display: block;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 26px;
  font-family: PingFang-SC-Medium;
  line-height: 26px;
  text-align: left;
}
.decoration_n {
  text-decoration: line-through;
}
.info4 {
  ////z-index: 38;
  display: block;
  overflow-wrap: break-word;
  color: rgba(240, 36, 14, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  line-height: 26px;
  text-align: left;
  margin-left: 10px;
}

.main7 {
  ////z-index: 34;
  height: 72px;
  border-radius: 0 0 14px 14px;
  background: #ffffff;
  background-repeat: no-repeat;
  background-size: 100%;
  align-self: center;
  margin-top: 1px;
  width: 710px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.wrap5 {
  ////z-index: auto;
  width: 650px;
  height: 37px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}

.txt5 {
  display: block;
  font-size: 26px;
  line-height: 37px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: left;
}

.word7 {
  display: block;
  overflow-wrap: break-word;
  color: rgba(240, 36, 14, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  line-height: 26px;
  text-align: right;
  margin-top: 4px;
}

.main8 {
  height: 188px;
  border-radius: 14px;
  background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_card@2x.png')
    no-repeat center;
  //background-repeat: no-repeat;
  background-size: 100%;
  // background: #ffffff linear-gradient(90deg, #313131 0%, #595959 100%);
  align-self: center;
  margin-top: 20px;
  width: 710px;
  justify-content: center;
  align-items: center;
  // display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main9 {
  //z-index: auto;
  width: 650px;
  height: 35px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  margin: 34px auto 0;
}
.main9_left {
  display: flex;
}
.outer1 {
  //z-index: 73;
  width: 34px;
  height: 35px;
  background: #ffffff linear-gradient(90deg, #313131 0%, #595959 100%);
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  img {
    width: 35px;
    height: 35px;
  }
}

.word8 {
  //z-index: 74;
  /*width: 168px;*/
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 227, 188, 1);
  font-size: 36px;
  font-family: PingFang-SC-Medium;
  line-height: 28px;
  text-align: left;
  margin-top: 4px;
  margin-left: 20px;
}
.n_timer {
  font-size: 20px;
  color: rgba(255, 219, 195, 0.7);
  padding: 0 30px;
  margin-top: 44px;
}
.txt6 {
  //z-index: 75;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 227, 188, 1);
  font-size: 28px;
  font-family: PingFangSC-Medium;
  line-height: 28px;
  text-align: left;
  margin-top: 4px;
  /*margin-left: 360px;*/
}

.main10 {
  position: fixed;
  bottom: 0px;
  //z-index: 4;
  height: 100px;
  background-color: rgba(255, 255, 255, 0.8);
  align-self: center;
  width: 750px;
  justify-content: center;
  align-items: flex-end;
  padding-right: 32px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.group2 {
  //z-index: auto;
  width: 678px;
  height: 72px;

  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex_sprice {
  line-height: 100px;
  //flex-direction: row;
  //display: flex;
}
.info5 {
  float: left;
  //z-index: 5;
  /*width: 72px;*/
  display: block;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 24px;
  font-family: PingFang-SC-Medium;
  // line-height: 24px;
  text-align: right;
  margin-top: 24px;
}

.layer5 {
  //z-index: 6;
  float: left;
  //height: 32px;
  overflow-wrap: break-word;
  text-align: center;
  margin-top: 20px;
  margin-left: 10px;
  box-sizing: border-box;
}

.word9 {
  font-size: 24px;
  font-family: PingFangSC-Medium;
  color: rgba(245, 34, 61, 1);
}

.txt7 {
  font-size: 24px;
  font-family: PingFangSC-Medium;
  color: rgba(245, 34, 61, 1);
}

.layer6 {
  //z-index: 91;
  height: 72px;
  border-radius: 36px;
  width: 332px;
  justify-content: center;
  align-items: center;
  display: flex;
  background: rgba(245, 34, 61, 1);
  flex-direction: column;
  box-sizing: border-box;
}

.txt8 {
  //z-index: 92;
  // width: 113px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 28px;
  font-family: PingFangSC-Regular;
  line-height: 28px;
  text-align: center;
}

.img2 {
  //z-index: 54;
  width: 750px;
  height: 68px;
  align-self: center;
}
.n_tab {
  padding: 38px 48px;
}
.n_title {
  font-size: 32px;
  color: #323233;
}
.n_red {
  font-size: 28px;
  color: #ef253c;
  margin-top: 20px;
}
.aliten_center {
  align-items: center;
}
.space_bettw {
  flex: 1;
  justify-content: space-between;
}
// 选择支付方式
.select_pay {
  width: 710px;
  background: rgba(255, 255, 255, 1);
  margin: 20px auto 0;
  border-radius: 14px;
  padding: 20px 24px;
  box-sizing: border-box;
  .just_beetw {
    justify-content: space-between;
  }
  .alitem_center {
    align-items: center;
    div {
      margin-left: 24px;
    }
  }
  .mt_two {
    margin-top: 38px;
  }
  img {
    width: 72px;
    height: 72px;
  }
  .wx_pay {
    font-size: 28px;
    color: #323233;
  }
  .aq_pay {
    font-size: 24px;
    color: #969799;
  }
  .blank {
    font-size: 28px;
    color: #323233;
    margin-right: 8px;
  }
  .blank_sn {
    font-size: 24px;
    color: #969799;
  }
}
</style>
